import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { fetchSearchInfo } from "redux/slices/schedule/scheduleSlice";

import iconAll from "assets/icons/icon_all_blue.svg";
import iconDrop from "assets/icons/icon_drop_black.svg";
import defaultThumbnail from "assets/image/default_coach_thumbnail.svg";
import { getScheduleTypeColor } from "utils/define";

import PopupSelect from "components/ui/popup/Select";
import DatePicker from "components/ui/popup/DatePicker";
import CalendarWeek from "components/ui/calendar/Week";

/**
 * [스케줄 검색 필터]
 */

export const ScheduleFilter = ({ onTouchEvents }) => {
  const dispatch = useDispatch();
  let {
    searchPartner,
    searchBranch,
    searchCoach,
    searchDate,
    searchScheduleType,
  } = useSelector((state) => state.schedule);
  const { seqPartner, seqPartnerBranch, branchUseYn, coachList } = useSelector(
    (state) => state.partner
  );

  const isPermission = !(branchUseYn == "Y" && seqPartnerBranch == 0);
  if (!isPermission) searchCoach = "";

  const eventHandler = {
    changeDate: (name, value) => {
      dispatch(
        fetchSearchInfo({
          searchDate: value,
        })
      );
    },
    changeCoachList: (name, value) => {
      dispatch(
        fetchSearchInfo({
          searchCoach: value,
        })
      );
    },
    changeScheduleType: (name, value) => {
      dispatch(
        fetchSearchInfo({
          searchScheduleType: value,
        })
      );
    },
    changeDatePicker: (value) => {
      const newDate = new Date(value);
      const oldDate = new Date(searchDate);
      /**
       * 만약 변경될 날짜의 마지막 일자가 이전 날짜 보다 작은 경우
       * 변경될 날짜의 마지막 일자로 변경한다.
       * (예 : 변경 전 날짜는 2022년 1월 31일인데, 2022년 2월로 선택 시 2022년 2월 28일로 변경)
       */
      if (oldDate.getDate() > newDate.getEndDateInMonth().getDate()) {
        newDate.setDate(newDate.getEndDateInMonth().getDate());
      } else {
        newDate.setDate(oldDate.getDate());
      }
      dispatch(
        fetchSearchInfo({
          searchDate: newDate.getCalendar(),
        })
      );
    },
    changeTouchEvent: (event) => {
      onTouchEvents(event);
    },
  };

  const render = () => {
    const getCoachList = () => {
      const newCoachList = isPermission
        ? (coachList || []).map((item) => {
            return {
              value: item.seqPartnerCoach,
              label: item.coachName,
              image: item.imgUrl || defaultThumbnail,
            };
          })
        : [];
      newCoachList.unshift({
        value: "",
        label: "전체",
        image: iconAll,
      });
      return newCoachList;
    };

    const getCoachInfo = () => {
      const coachInfo =
        getCoachList().filter((item) => {
          return item.value == searchCoach;
        })[0] || {};
      return (
        <div className="item">
          <img src={coachInfo.image} />
          {searchCoach ? coachInfo.label : "강사 전체"}
        </div>
      );
    };

    const getScheduleTypeList = () => {
      return [
        {
          value: "",
          label: "전체",
        },
        {
          value: "APPOINTMENT",
          label: "개인레슨",
        },
        {
          value: "CLASS",
          label: "그룹수업",
        },
        {
          value: "OT",
          label: "OT",
        },
        {
          value: "CONSULTING",
          label: "상담",
        },
        {
          value: "ETC",
          label: "기타",
        },
      ];
    };

    const getScheduleTypeInfo = () => {
      const scheduleTypeInfo =
        getScheduleTypeList().filter((item) => {
          return item.value == searchScheduleType;
        })[0] || {};

      const scheduleTypeColor = searchScheduleType
        ? getScheduleTypeColor(searchScheduleType)
        : "blue";

      return (
        <div className="item">
          <span className={scheduleTypeColor}></span>
          {searchScheduleType ? scheduleTypeInfo.label : "스케줄 전체"}
        </div>
      );
    };

    return (
      <Wrapper>
        <div className="top">
          <div className="left">
            <PopupSelect
              title="강사 선택"
              options={getCoachList()}
              isBlock={true}
              isSearch={true}
              value={searchCoach}
              onChange={eventHandler.changeCoachList}
            >
              {getCoachInfo()}
            </PopupSelect>
          </div>
          <div className="right">
            <PopupSelect
              title="스케줄 선택"
              options={getScheduleTypeList()}
              isBlock={true}
              value={searchScheduleType}
              onChange={eventHandler.changeScheduleType}
            >
              {getScheduleTypeInfo()}
            </PopupSelect>
          </div>
        </div>
        <div className="bottom">
          <DatePicker
            className="datepicker"
            mode="month"
            date={searchDate}
            format="yyyy년 sm월"
            onChange={eventHandler.changeDatePicker}
          />
          <div
            onTouchStartCapture={eventHandler.changeTouchEvent}
            onTouchEndCapture={eventHandler.changeTouchEvent}
            onTouchCancelCapture={eventHandler.changeTouchEvent}
          >
            <CalendarWeek
              className="calendar"
              value={searchDate}
              import={true}
              onChange={eventHandler.changeDate}
            />
          </div>
        </div>
      </Wrapper>
    );
  };
  return render();
};

const Wrapper = styled.div`
  & {
    padding: 0 24px 8px 24px;
    background-color: white;
  }
  & > .top {
    display: flex;
    margin: 0 -2px;
    height: 52px;
    border-radius: 50px;
    box-shadow: 0px 1px 10px rgba(224, 228, 237, 0.5);
    border: 1px solid var(--border);
    font-weight: 600;
  }
  & > .top > div {
    position: relative;
    width: 50%;
    padding: 0 30px 0 20px;
    background: url(${iconDrop}) no-repeat center right 18px / 0.55em;
  }
  & > .top > div + div {
    margin-left: 0 !important;
  }
  & > .top > div + div:after {
    content: "";
    position: absolute;
    left: 0;
    top: 12px;
    bottom: 12px;
    border-right: 1px solid var(--border);
  }
  & > .top > div > div > div {
    display: flex;
    line-height: 50px;
    align-items: center;
    justify-content: left;
  }

  .item {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .item > * {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
    margin-top: -2px;
  }
  .item img {
    width: 32px;
    height: 32px;
    border-radius: 100%;
    object-fit: cover;
  }
  .item span {
    width: 8px;
    height: 8px;
    background-color: var(--darkGray);
    border-radius: 100%;
  }
  .item span.blue {
    background-color: var(--blue);
  }
  .item span.orange {
    background-color: var(--orange);
  }
  .item span.purple {
    background-color: var(--purple);
  }

  .bottom {
    position: relative;
  }
  .bottom .date {
    font-size: 1.5rem;
    font-weight: bold;
  }
  .bottom .date > div {
    margin-left: 0.5em;
  }
  .bottom .datepicker {
    margin-top: 16px;
  }
  .bottom .datepicker h4 {
    font-weight: 600;
    color: #4c5874;
  }
  .bottom .calendar {
    margin: 10px -12px 0 -12px;
  }
`;

export default ScheduleFilter;
